import * as shopifyCart from "@shopify/theme-cart";
import { store } from "../../config/store";
import { types } from "./types";
import app from "../../../lib/app";

export const subscribeUpdateCart = () => {
  store.subscribe(({ type, payload }) => {
    if (type === `cart/${types.UPDATE_CART}`) {
      app.emit("cart:updated", payload);
      const updatedItems = handleUpsellLineItemProperty(payload);
      if (updatedItems) {
        store.dispatch("cart/fetchCart");
      }
    }
  });
};

const handleUpsellLineItemProperty = (cartState) => {
  const { items } = cartState;
  let changedItem = false;
  const updatedItems = items.map((item) => {
    const upsell = item.properties._upsell;
    if (!upsell) return item;
    const validUpsell = validateLineItemUpsell(upsell, items);
    const activeUpsell = item.properties._upsell_active;

    if (validUpsell && !activeUpsell) {
      changedItem = true;
      const newProperties = {
        ...item.properties,
        _upsell_active: upsell.key || "true",
        _upsell: {
          ...upsell,
        },
      };

      shopifyCart.updateItem(item.key, {
        properties: newProperties,
      });

      return {
        ...item,
        properties: newProperties,
      };
    } else if (!validUpsell && activeUpsell) {
      changedItem = true;
      const newProperties = { ...item.properties };
      delete newProperties._upsell_active;

      shopifyCart.updateItem(item.key, {
        properties: newProperties,
      });

      return {
        ...item,
        properties: newProperties,
      };
    }

    return item;
  });

  if (changedItem) {
    return updatedItems;
  }

  return false;
};

const validateLineItemUpsell = (upsell, cartItems) => {
  const { requiredProducts, requiredVariants, or } = upsell;
  if (or) {
    const matchedProduct = cartItems.find((item) =>
      requiredProducts.includes(item.product_id)
    );
    if (matchedProduct) return true;
    const matchedVariant = cartItems.find((item) =>
      requiredVariants.includes(item.id)
    );
    if (matchedVariant) return true;
  } else {
    const hasAllRequiredProducts = requiredProducts.every((productId) =>
      cartItems.find((item) => item.product_id === productId)
    );
    const hasAllRequiredVariants = requiredVariants.every((variantId) =>
      cartItems.find((item) => item.id === variantId)
    );

    if (hasAllRequiredProducts && hasAllRequiredVariants) return true;
  }
  return false;
};
